<template>
  <div id="addRole">
    <div class="title">基本信息</div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
      <FormItem label="优惠券名称" prop="name">
        <Input
          v-model="formValidate.name"
          :maxlength="10"
          placeholder="请输入优惠券名称，不能超过10个字符"
          style="width: 400px;"
          clearable
        ></Input>
        <span>{{roleLength}}/10</span>
      </FormItem>

      <FormItem label="使用范围" prop="dis_type">
        <RadioGroup v-model="formValidate.dis_type" @on-change="onDisTypeChange">
          <Radio label="1">
            <span>班课</span>
          </Radio>
          <!-- <Radio label="4">
            <span>一对一</span>
          </Radio> -->
          <Radio label="2">
            <span>图书</span>
          </Radio>
          <!-- <Radio label="3">
            <span>文库</span>
          </Radio>-->
        </RadioGroup>

        <FormItem v-if="formValidate.dis_type == '1'" prop="scope_type">
          <RadioGroup v-model="formValidate.scope_type">
            <Radio label="1">
              <span>全部课程</span>
            </Radio>
            <Radio label="2">
              <span>指定分类</span>
            </Radio>
            <Radio label="3">
              <span>指定课程</span>
            </Radio>
          </RadioGroup>

          <Row v-show="formValidate.scope_type == '2'" style="margin-top:6px">
            <Tag
              type="border"
              closable
              v-for="classify in classifys"
              :key="classify.id"
              @on-close="useRangeDelete(classifys, classify.id)"
            >{{classify.title}}</Tag>
            <Button class="mar" type="default" @click="showSelectClassify=true">
              <i class="ivu-icon ivu-icon-ios-add"></i>选择分类
            </Button>
          </Row>

          <Row v-show="formValidate.scope_type == '3'" style="margin-top:6px">
            <Tag
              type="border"
              closable
              v-for="course in courses"
              :key="course.id"
              @on-close="useRangeDelete(courses, course.id)"
            >{{course.title}}</Tag>
            <Button class="mar" type="default" @click="showSelectCourse=true">
              <i class="ivu-icon ivu-icon-ios-add"></i>选择课程
            </Button>
          </Row>
        </FormItem>

        <FormItem v-else-if="formValidate.dis_type == '4'" prop="scope_type">
          <RadioGroup v-model="formValidate.scope_type">
            <Radio label="1">
              <span>全部约课</span>
            </Radio>
            <Radio label="2">
              <span>指定约课讲师</span>
            </Radio>
          </RadioGroup>

          <Row v-show="formValidate.scope_type == 2" style="margin-top:6px">
            <Tag
              type="border"
              closable
              v-for="teacher in teachers"
              :key="teacher.id"
              @on-close="useRangeDelete(teachers, teacher.id)"
            >{{teacher.title}}</Tag>
            <Button class="mar" type="default" @click="showSelectTeacher=true">
              <i class="ivu-icon ivu-icon-ios-add"></i>选择约课讲师
            </Button>
          </Row>
        </FormItem>

        <FormItem v-if="formValidate.dis_type == '2'" prop="scope_type">
          <RadioGroup v-model="formValidate.scope_type">
            <Radio label="1">
              <span>全部图书</span>
            </Radio>
            <Radio label="2">
              <span>指定分类</span>
            </Radio>
            <Radio label="3">
              <span>指定图书</span>
            </Radio>
          </RadioGroup>

          <Row v-show="formValidate.scope_type == '2'" style="margin-top:6px">
            <Tag
              type="border"
              closable
              v-for="classify in bookClassifys"
              :key="classify.id"
              @on-close="useRangeDelete(bookClassifys, classify.id)"
            >{{classify.title}}</Tag>
            <Button class="mar" type="default" @click="showSelectBookClassify=true">
              <i class="ivu-icon ivu-icon-ios-add"></i>选择分类
            </Button>
          </Row>

          <Row v-show="formValidate.scope_type == '3'" style="margin-top:6px">
            <Tag
              type="border"
              closable
              v-for="book in books"
              :key="book.id"
              @on-close="useRangeDelete(books, book.id)"
            >{{book.title}}</Tag>
            <Button class="mar" type="default" @click="showSelectBook=true">
              <i class="ivu-icon ivu-icon-ios-add"></i>选择图书
            </Button>
          </Row>
        </FormItem>
      </FormItem>

      <FormItem label="类型" prop="receive_type">
        <RadioGroup v-model="formValidate.receive_type">
          <Radio label="1" :disabled="formValidate.dis_type != '4'?false:true">领取</Radio>
          <Radio label="2">赠送</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="优惠规则" prop="discounted_price">
        满
        <Input
          class="mar"
          v-model="formValidate.full_reduction"
          type="number"
          style="width: 150px;"
        />减
        <Input
          class="mar"
          v-model="formValidate.discounted_price"
          type="number"
          style="width: 150px;"
        />
      </FormItem>
      <FormItem label="有效期" prop="valid_type">
        <RadioGroup v-model="formValidate.valid_type">
          <Radio label="1">
            <span>固定天数</span>
          </Radio>
          <Radio label="2">
            <span>固定时间段</span>
          </Radio>
          <div>
            <Input
              placeholder="请输入天数"
              v-show="formValidate.valid_type == 1"
              type="text"
              style="width: 100px;"
              v-model="valid_day"
              @keydown.native="dayKeydown"
            />
            <DatePicker
              v-show="formValidate.valid_type == 2"
              :value="timeRange"
              format="yyyy-MM-dd"
              type="daterange"
              @on-change="selectTime"
              placeholder="开始时间 - 结束时间"
              style="width:200px"
              :editable="false"
            ></DatePicker>
          </div>
        </RadioGroup>
      </FormItem>
      <FormItem label="发放数量" prop="num">
        <Input v-model="formValidate.num" type="number" placeholder="请输入" style="width: 400px;"></Input>
      </FormItem>
      <FormItem label="每人限领" prop="restrict_num">
        限领
        <Input class="mar" type="number" style="width: 60px;" v-model="formValidate.restrict_num" />张
        <span style="color:red; margin-left:20px;">* 至少限领一张</span>
      </FormItem>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'CouponManage'}">返回</Button>
        <Button size="large" style="margin: 0 15px;" @click="submits('formValidate',0)">保存并返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submits('formValidate',1)"
        >保存并发放</Button>
      </FormItem>
    </Form>
    <Modal
      class="grid-select"
      v-model="showSelectCourse"
      title="选择课程"
      @on-ok="confirmSelectCourse"
      @on-cancel="$refs.course.recoverSelectedItems(courses)"
      width="800"
      scrollable
    >
      <CourseSelect ref="course" :selectedItems="courses"></CourseSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectClassify"
      title="选择分类"
      @on-ok="confirmSelectClassify"
      width="800"
      scrollable
    >
      <Classify ref="classify" data-url="/api/course/classify" title="name" :checks="classifys"></Classify>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectTeacher"
      title="选择约课讲师"
      @on-ok="confirmSelectTeacher"
      @on-cancel="$refs.teacher.recoverSelectedItems(teachers)"
      width="800"
      scrollable
    >
      <TeacherOtoSelect ref="teacher" :selectedItems="teachers"></TeacherOtoSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectBookClassify"
      title="选择分类"
      @on-ok="confirmSelectBookClassify"
      width="800"
      scrollable
    >
      <Classify ref="bookClassify" data-url="/api/course/classify" :checks="bookClassifys"></Classify>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectBook"
      title="选择图书"
      @on-ok="confirmSelectBook"
      @on-cancel="$refs.book.recoverSelectedItems(books)"
      width="800"
      scrollable
    >
      <BookSelect ref="book" :selectedItems="books"></BookSelect>
    </Modal>
  </div>
</template>

<script>
import TeacherOtoSelect from "@/components/GridSelect/TeacherOtoSelect.vue";
import CourseSelect from "@/components/GridSelect/CourseSelect.vue";
import BookSelect from "@/components/GridSelect/BookSelect.vue";
import Classify from "@/components/TreeSelect/Classify";
export default {
  name: "addRole",
  components: {
    TeacherOtoSelect,
    CourseSelect,
    BookSelect,
    Classify
  },
  data() {
    return {
      id: this.$route.query.id || "",
      formValidate: {
        name: "",
        receive_type: "",
        dis_type: "1", //默认班课  4为一对一
        scope_type: "", //1全部约课/全部课程  2指定分类/指定讲师  3指定课程（班课）
        full_reduction: "",
        discounted_price: "",
        valid_type: "",
        num: "",
        restrict_num: ""
      },
      courses: [], //课程列表 最后列表内容转为commodity的jason数组传送所选信息  id与name||title
      classifys: [], //分类列表 同上
      teachers: [], //讲师列表 同上
      bookClassifys: [], //图书分类列表
      books: [], //图书列表
      timeRange: ["", ""],
      valid_day: "",
      roleLength: 0,
      descLength: 0,
      ruleValidate: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        dis_type: [{ required: true, message: "请选择" }],
        receive_type: [{ required: true, message: "请选择" }],
        scope_type: [{ required: true, message: "请选择" }],
        valid_type: [{ required: true, message: "请选择" }],
        discounted_price: [{ required: true, message: "请输入" }],
        num: [{ required: true, message: "请输入数量" }],
        restrict_num: [{ required: true, message: "请输入" }]
      },
      showSelectCourse: false,
      showSelectClassify: false,
      showSelectTeacher: false,
      showSelectBookClassify: false,
      showSelectBook: false
    };
  },
  created() {
    this.getData();
  },
  watch: {
    "formValidate.name": {
      handler: function() {
        this.roleLength = this.formValidate.name.length;
      },
      deep: true
    }
  },
  methods: {
    onDisTypeChange() {
      if (this.formValidate.dis_type == "4") {
        this.formValidate.receive_type = "2";
      }
      this.formValidate.scope_type = "1";
    },
    getData() {
      if (this.id != "") {
        this.$http.get(`/api/coupon/${this.id}`).then(res => {
          res.valid_type = res.valid_type.toString();
          res.scope_type = res.scope_type.toString();
          res.receive_type = res.receive_type.toString();
          res.dis_type = res.dis_type.toString();
          res.discounted_price = res.discounted_price / 100;
          res.full_reduction = res.full_reduction / 100;
          this.formValidate = {
            name: res.name,
            receive_type: res.receive_type,
            scope_type: res.scope_type,
            full_reduction: res.full_reduction,
            discounted_price: res.discounted_price,
            valid_type: res.valid_type,
            num: res.num,
            restrict_num: res.restrict_num,
            dis_type: res.dis_type
          };
          if (res.dis_type == 1) {
            if (res.scope_type == 2) {
              this.classifys = res.commodity;
            } else if (res.scope_type == 3) {
              this.courses = res.commodity;
            }
          } else if (res.dis_type == 2) {
            if (res.scope_type == 2) {
              this.bookClassifys = res.commodity;
            } else {
              this.books = res.commodity;
            }
          } else {
            this.teachers = res.commodity;
          }

          if (res.valid_type == 1) {
            this.valid_day = res.valid_day;
          } else {
            this.timeRange = [res.valid_start * 1000, res.valid_end * 1000];
          }
        });
      }
    },
    selectTime(e) {
      this.timeRange = e;
    },
    submits(name, type) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let obj = this.formValidate;
          obj.grant = type;
          if (!obj.full_reduction) {
            this.$Message.error("请输入优惠规则");
            return;
          }
          if (obj.full_reduction - obj.discounted_price < 0) {
            this.$Message.error("优惠规则有误，请重新输入");
            return;
          }
          if (obj.scope_type == 2) {
            //指定讲师与指定分类都是scope_typr=2
            if (obj.dis_type == 1) {
              if (this.classifys.length == 0) {
                this.$Message.error("请选择课程分类");
                return;
              }
              obj.commodity_id = this.listToCom(this.classifys);
            } else if (obj.dis_type == 4) {
              //指定讲师
              if (this.teachers.length == 0) {
                this.$Message.error("请选择讲师");
                return;
              }
              obj.commodity_id = this.listToCom(this.teachers);
            } else if (obj.dis_type == 2) {
              //指定图书分类
              if (!this.bookClassifys.length) {
                this.$Message.error("请选择图书分类");
                return;
              }
              obj.commodity_id = this.listToCom(this.bookClassifys);
            } else {
              obj.scope_type = 1;
            }
          } else if (obj.scope_type == 3) {
            if (obj.dis_type == 1) {
              //选择课程
              if (this.courses.length == 0) {
                this.$Message.error("请选择课程");
                return;
              }
              obj.commodity_id = this.listToCom(this.courses);
            } else if (obj.dis_type == 2) {
              //选择图书
              if (this.books.length == 0) {
                this.$Message.error("请选择图书");
                return;
              }
              obj.commodity_id = this.listToCom(this.books);
            } else {
              obj.scope_type = 1;
            }
          }

          if (obj.valid_type == 1) {
            obj.valid_day = this.valid_day;
            if (!obj.valid_day) {
              this.$Message.error("请输入有效期");
              return;
            }
            if (isNaN(obj.valid_day)) {
              this.$Message.error("有效天数格式错误");
              return;
            }
            if (parseFloat(obj.valid_day) < 0) {
              this.$Message.error("有效天数必须大于0");
              return;
            }
          } else {
            if (this.timeRange[0] && this.timeRange[1]) {
              obj.valid_start = this.timeRange[0];
              obj.valid_end = this.timeRange[1];
            } else {
              this.$Message.error("请输入有效期");
              return;
            }
          }

          if (this.id == "") {
            this.$http.post("/api/coupon", obj).then(() => {
              this.$router.push({ name: "CouponManage" });
            });
          } else {
            this.$http.put(`/api/coupon/${this.id}`, obj).then(() => {
              this.$router.push({ name: "CouponManage" });
            });
          }
        } else {
          this.$Message.error("请输入完整!");
        }
      });
    },
    listToCom(listName) {
      let list = [];
      listName.forEach(item => {
        list.push({
          name: item.title,
          id: item.id
        });
      });
      return JSON.stringify(list);
    },
    confirmSelectCourse() {
      this.showSelectCourse = false;
      let list = this.$refs.course.getSelectList();
      this.courses = list;
    },
    confirmSelectClassify() {
      this.showSelectClassify = false;
      let list = this.$refs.classify.getSelectList();
      this.classifys = list;
    },
    confirmSelectTeacher() {
      this.showSelectTeacher = false;
      let list = this.$refs.teacher.getSelectList();
      list.forEach(i => {
        i.title = i.teacher_name;
        i.id = i.teacher_id;
      });
      this.teachers = list;
    },
    confirmSelectBookClassify() {
      this.showSelectBookClassify = false;
      let list = this.$refs.bookClassify.getSelectList();
      this.bookClassifys = list;
    },
    confirmSelectBook() {
      this.showSelectBook = false;
      let list = this.$refs.book.getSelectList();
      list.forEach(i => {
        i.title = i.name;
      });
      this.books = list;
    },
    useRangeDelete(aryData, id) {
      if (!aryData || !aryData.length) return;
      for (let i = 0; i < aryData.length; ++i) {
        if (aryData[i].id == id) {
          aryData.splice(i, 1);
          break;
        }
      }
    },
    dayKeydown(event) {
      if (event.keyCode == 190 || event.keyCode == 189) {
        event.preventDefault();
      }
      if (event.keyCode == 48 && event.target.value == "") {
        event.preventDefault();
      }
      if (event.keyCode == 8) {
        let value = event.target.value;
        if (value.length == 2 && value[0] == "0") {
          event.target.value = "";
          let customEvent = document.createEvent("HTMLEvents");
          customEvent.initEvent("input", false, true);
          event.target.dispatchEvent(customEvent);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#addRole {
  padding: 15px;
  background: #fff;
  .mar {
    margin: 0 6px;
  }
}
.title {
  position: relative;
  margin-bottom: 10px;
  padding: 5px 15px;
  font-size: 16px;
}
.title::before {
  display: block;
  position: absolute;
  left: 0;
  top: 7px;
  content: "";
  height: 20px;
  background-color: #2d8cf0;
  width: 4px;
}
</style>
